export * from './buddyBooks';
export * from './students';

// process.env.REACT_APP_GAME_URL;
export const ROOT_URL = process.env.REACT_APP_ROOT_URL;
export const GAME_URL = process.env.REACT_APP_GAME_URL;